import client from '../config/AxiosConfig';

export const GetBudgets = async (currentPage, limit, filters) =>
  await client.get(`/budgets/${currentPage}/${limit}?filter=${filters}`);

export const GetBudget = async (id) => await client.get(`/budgets/${id}`);
